import { get, post, put, remove } from '../services/common/common.service';
import { eTrack, eTrackEndPoints } from '../constants/endpoint';

export const eTrackExistingQuoteSearch = (payload) =>
  post(eTrack.fetchExistingQuotes, payload);

export const eTrackExistingQuoteHistory = (payload) =>
  post(eTrack.getQuoteHistory, payload);

export const eTrackExistingQuoteDetail = (payload) =>
  get(`${eTrack.getQuoteDetail}/${payload}`);

export const eTrackExistingQuoteItems = (payload) =>
  get(
    `${eTrack.getQuoteItems}?entitlementQuoteId=${payload.entitlementQuoteId}&isPagination=${payload.isPagination}&PageIndex=${payload.PageIndex}&RecordCount=${payload.RecordCount}`
  );

export const fetchEtrackQuote = (payload) => {
  return post(eTrackEndPoints.searchQuote, payload);
};
export const fetchSite = (payload) => {
  return get(eTrackEndPoints.siteName, payload);
};

export const fetchServiceModal = (payload) =>
  get(
    `${eTrackEndPoints.serviceModal}?id=${payload.id}&name=${payload.name}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}&pscustomercode=${payload.customerCode}`,
    payload
  );

// Site Type DropDown - GET API to fetch the data
export const fetchSiteTypeData = () => get(eTrackEndPoints.siteType);

//E-Track - Fetching Quote Types
export const fetchQuoteTypes = (payload) => {
  return get(eTrackEndPoints.quoteTypes, payload);
};

//E-Track - Create Quote
export const createQuote = (payload) => {
  return post(eTrackEndPoints.createQuote, payload);
};

//E-Track - Create Quote - Adding Items not selected if Quote type is Upgrade/Move Warranties and SiteSync Flag is 'y'
export const createQuoteAddItems = (payload) => {
  return post(eTrackEndPoints.createQuoteAddItems, payload);
};

//Fetch Quote Details
export const fetchQuoteDetails = (payload) => {
  return get(`${eTrackEndPoints.getQuoteDetail}/${payload}`);
};

//E-Track - Save Quote
export const saveQuote = (payload) => {
  return put(eTrackEndPoints.saveQuote, payload);
};

//E-Track - Delete Quote
export const deleteQuote = (payload) => {
  return post(eTrackEndPoints.deleteQuote, payload);
};

//E-Track - Submit Quote
export const submitQuote = (payload) => {
  return post(eTrackEndPoints.submitQuote, payload);
};

//Fetch Quote Details
export const fetchQuoteDetailsForEmail = (payload) => {
  return get(
    `${eTrackEndPoints.getQuoteDetailForEmail}/${payload.entitlementQuoteId}/${payload.quoteStatusId}`
  );
};
//Fetch Quote Details
export const fetchQuoteDetailsForCopyEmail = (payload) => {
  return get(
    `${eTrackEndPoints.getQuoteDetailForEmail}/${payload.entitlementQuoteId}/${payload.quoteStatusId}`
  );
};

//Fetch complete Job
export const getJobComplete = (payload) => {
  return post(eTrackEndPoints.getJobComplete, payload);
};

//Fetch Export Reseller Quote
export const getExportResellerQuote = (payload) => {
  return get(`${eTrackEndPoints.getExportResellerQuote}?quoteId=${payload}`);
};

//Fetch Export Client Quote
export const getExportClientQuote = (payload) => {
  return get(`${eTrackEndPoints.getExportClientQuote}?quoteId=${payload}`);
};

//--------------------------------Update Quote--------------------------------

//E-Track - Quote Details - Grid - Add Items - Submit
export const submitQuoteItems = (payload) => {
  return post(eTrackEndPoints.submitQuoteItems, payload);
};

export const addItemsSiteSyncMultipleSites = (payload) => {
  return put(eTrackEndPoints.addItemsForMultipleSites, payload);
};

//E-Track - Quote Details - Grid - Remove / Delete Selected Quote Items
export const deleteQuoteItemData = (payload) => {
  return remove(eTrackEndPoints.deleteQuoteItems, payload);
};

//E-Track - Quote Details - Grid - Update - Site Search
export const fetchQuoteUpdateSiteData = (payload) => {
  return post(eTrackEndPoints.updateQuoteItemsSiteSearch, payload);
};

//E-Track - Quote Details - Grid - Update - Service Level Drop down
export const fetchQuoteUpdateServiceLevelData = (payload) => {
  return get(
    `${eTrackEndPoints.updateQuoteItemsServiceLevel}?contractId=${payload.contractId}&contractZoneId=${payload.contractZoneId}&priceClassId=${payload.priceClassId}`
  );
};

//E-Track - Quote Details - Grid - Update - Warranty Should / Status Drop Down
export const fetchQuoteUpdateWarrantyStatusData = (payload) => {
  return get(eTrackEndPoints.updateQuoteItemsWarrantyShould, payload);
};

//E-Track - Quote Details - Grid - Update Quote Item (Update Click)
export const updateQuoteItemListData = (payload) => {
  return post(eTrackEndPoints.updateQuoteItem, payload);
};

//E-Track - Quote Details - Grid - Fetch Entitlements of Site
export const fetchEntitlementsOfSite = (payload) => {
  return get(
    `${eTrackEndPoints.getEntitlementsOfSite}?customerId=${payload.customerId}&siteId=${payload.siteId}`
  );
};

//E-Track - External User - Get MCN List
export const fetchMCNListForExternalUser = (payload) => {
  return post(eTrackEndPoints.getExternalUserMCNList, payload);
};
